import api from "./api";
import endpoints from "./endpoints";

export default {
  get: async function (catalogMappingProjectId, catalogMappingId, isReferential, abortSignal) {
    return api
      .get(endpoints.mapping.catalogFields.get, {
        params: { catalogMappingProjectId, catalogMappingId, isReferential },
        signal: abortSignal
      })
      .then((x) => Promise.resolve(x.data));
  },
  rename: async function (name, projectId, targetNodeIds) {
    const result = await api.post(endpoints.mapping.catalogFields.rename, targetNodeIds, { params: { name, catalogMappingProjectId: projectId } });
    return result.data;
  },
  reset: async function (projectId, targetNodeIds) {
    const result = await api.post(endpoints.mapping.catalogFields.reset, targetNodeIds, { params: { catalogMappingProjectId: projectId } });
    return result.data;
  },
  create: async function (catalogMappingProjectId, mappings) {
    const formattedMappings = mappings.map((x) => {
      return {
        catalogMappingId: x.catalogMappingId,
        catalogMappingTargetNodeId: x.targetFieldId,
        targetNodeName: x.targetNodeName,
        sourceExpression: x.sourceExpression
      };
    });
    const result = await api.post(endpoints.mapping.catalogFields.create, formattedMappings, {
      params: { catalogMappingProjectId }
    });
    return result.data;
  },
  update: async function (mappings) {
    const formattedUpdateList = mappings.map((x) => {
      return { catalogFieldMappingId: x.catalogFieldMappingId, sourceExpression: x.sourceExpression };
    });
    const result = await api.post(endpoints.mapping.catalogFields.update, formattedUpdateList);
    return result.data;
  },
  moveUp: async function (projectId, targetSystem, nodeIds, targetAttributeGroup) {
    const result = await api.post(endpoints.mapping.catalogFields.move, nodeIds, {
      params: {
        catalogMappingProjectId: projectId,
        targetSystem,
        isMoveDown: false,
        targetAttributeGroup
      }
    });
    return result.data;
  },
  moveDown: async function (projectId, targetSystem, nodeIds, targetAttributeGroup) {
    const result = await api.post(endpoints.mapping.catalogFields.move, nodeIds, {
      params: {
        catalogMappingProjectId: projectId,
        targetSystem,
        isMoveDown: true,
        targetAttributeGroup
      }
    });
    return result.data;
  },
  getSourceTreeFields: async function (catalogId, mode, language, attributeGroupId, abortSignal) {
    const response = await api.get(endpoints.mapping.sourceTree.fields.get, {
      params: { catalogId, mode, language, attributeGroupId },
      signal: abortSignal
    });
    return response.data;
  },
  delete: async function (targetNodeIds) {
    const result = await api.post(endpoints.mapping.catalogFields.delete, targetNodeIds);
    return result.data;
  },
  deleteAll: async function (catalogMappingProjectId, attributeGroupId) {
    return api
      .post(endpoints.mapping.catalogFields.deleteAll, {}, { params: { catalogMappingProjectId, attributeGroupId } })
      .then((x) => Promise.resolve(x.data));
  }
};
